import { FlexColumn, FlexRow, LabeledInput } from '@gorila-shared-ui/components';
import { Checkbox } from 'baseui/checkbox';
import { useEffect } from 'react';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import * as uuid from 'uuid';
import { REQUIRED_FIELD_TEXT } from '../../constants/app';
import { useForms } from '../../hooks/useForms';
import { useStyles } from '../../hooks/useStyles';
import {
  editFormState,
  editFormTouchedState,
  editFormValidState,
  formDetailFieldsState,
  formDetailState,
  selectedFormFieldState,
} from '../../storage/formStates';
import { FormCore, FormRequest, FormRequestTouched } from '../../types/forms';
import { TenantSelect } from '../tenants/TenantSelect';
import { AddFormFieldButton } from './AddFormFieldButton';
import { FormFieldConfig } from './FormFieldConfig';
import { FormFieldConfigModal } from './FormFieldConfigModal';

export function FormFields() {
  const { theme, css } = useStyles();
  const formDetail = useRecoilValue(formDetailState);
  const [editForm, setEditForm] = useRecoilState(editFormState);
  const editFormValid = useRecoilValue(editFormValidState);
  const [editFormTouched, setEditFormTouched] = useRecoilState(editFormTouchedState);
  const resetEditFormTouchedState = useResetRecoilState(editFormTouchedState);
  const resetEditForm = useResetRecoilState(editFormState);
  const { onTouched } = useForms<FormRequest, FormRequestTouched>(setEditForm, setEditFormTouched);
  const formDetailFields = useRecoilValue(formDetailFieldsState);
  const [selectedFormField, setSelectedFormField] = useRecoilState(selectedFormFieldState);

  useEffect(() => {
    resetEditFormTouchedState();
    return () => {
      resetEditForm();
      resetEditFormTouchedState();
    };
  }, []);

  const onChangeInput = (key: keyof FormCore, value: any) => {
    setEditForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <>
      <FlexColumn>
        <LabeledInput
          label="Nombre"
          placeholder="Ingresa el nombre del formulario"
          value={editForm.name}
          onChange={(value) => onChangeInput('name', value)}
          onBlur={() => onTouched('nameTouched')}
          error={editFormTouched.nameTouched && !editFormValid.name && REQUIRED_FIELD_TEXT}
          required
        />
        <TenantSelect
          label="Clientes"
          selectedTenantIds={editForm.tenants.length > 0 ? editForm.tenants : undefined}
          tenants={formDetail?.tenants}
          onChangeTenantIds={(value) => {
            onChangeInput('tenants', value);
          }}
          isMulti
        />
        <Checkbox
          checked={editForm.active}
          onChange={(e) => onChangeInput('active', e.target.checked)}
        >
          Activo
        </Checkbox>
      </FlexColumn>
      {formDetailFields.length > 0 && (
        <FlexColumn>
          {formDetailFields.map((field, index) => (
            <FormFieldConfig
              field={field}
              index={index}
              key={index}
            />
          ))}
        </FlexColumn>
      )}
      <FlexRow
        centered
        classNames={css({
          position: 'sticky',
          bottom: 0,
          background: theme.colors.backgroundPrimary,
          paddingTop: theme.sizing.scale300,
        })}
      >
        <AddFormFieldButton
          onSelection={({ id: fieldType }) => {
            setSelectedFormField({
              fieldType,
              id: uuid.v4(),
              index: formDetailFields.length,
              uncreated: true,
            });
          }}
        />
      </FlexRow>
      <FormFieldConfigModal isOpen={selectedFormField !== undefined} />
    </>
  );
}
